import { createContext } from 'react'

export type PricingContextValue = {
  status: 'loading' | 'ready' | 'error'
  /** Preço atual. `null` enquanto carrega ou se o backend estiver indisponível. */
  price: number | null
  /** Preço "De" riscado. `null` quando não há desconto. */
  originalPrice: number | null
  discountPercent: number | null
  /** Preço formatado ("R$ 34,90") ou um marcador neutro enquanto carrega. */
  priceLabel: string
  originalPriceLabel: string | null
  hasDiscount: boolean
}

export const PricingContext = createContext<PricingContextValue | null>(null)
